import { handleActions } from "redux-actions";
import { fromJS } from "immutable";
import types from "../types";

const INITIAL_STATE = fromJS({
  isLoading: false,
  reportsData: [],
  message: '',
});

const reducer = handleActions(
  {
    [types.LIST]: (state, { payload }) => state.set("isLoading", true),
    [types.LIST_FAIL]: (state, { payload }) => state.set("isLoading", false),
    [types.LIST_SUCCESS]: (state, { payload: response }) =>
      state.set("isLoading", false).set("reportsData", response.data),
    [types.DELETE]: (state, { payload }) => state.set("isLoading", true),
    [types.DELETE_FAIL]: (state, { payload }) => state.set("isLoading", false),
    [types.DELETE_SUCCESS]: (state, { payload: response }) =>
        state.set("isLoading", false).set("message", response.data),
  },
  INITIAL_STATE
);

export default reducer;
